import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-11',
  templateUrl: './dpto11.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto11Component extends DepartmentBase {
  municipalities = [{
    "id": 149,
    "code": "11001",
    "name": "Bogotá, D.C.",
    "state": "1",
    "department_code": "11"
  }]
}
